import React, { useState } from 'react';
import './opportunities.scss';
import { HEADER_STYLES } from '../../constants/uiConstants';
import { PageHeader } from '../../component/page-header/page-header';
import OpportunityList from './index';
import { OpportunitySubscriptionButton } from 'component/Buttons/OpportunitySubscriptionButton';
import { IOpportunityFilter } from './models/model';
import { OpportunityFilterContext } from './FilterContext';
import { OpportunityGenerateReportButton } from 'component/Buttons/OpportunityGenerateReportButton';

const PATH_NAME = '/opportunities';

interface Props {
  editorSwitch: boolean;
}

function Opportunities({ editorSwitch }: Props): React.ReactElement {
  const [filterValue, setFilterValue] = useState<IOpportunityFilter>({
    selectedPositions: [],
    selectedTechnologies: [],
    page: 0,
    searchText: '',
    selectedChallenges: [],
  });

  const toGetPositionsValue = (positions: string[]) => {
    setFilterValue((prev) => {
      const updatedFilterValue = { ...prev };
      updatedFilterValue.selectedPositions = positions;
      return updatedFilterValue;
    });
  };

  const toGetChallengesValue = (challenges: string[]) => {
    setFilterValue((prev) => {
      const updatedFilterValue = { ...prev };
      updatedFilterValue.selectedChallenges = challenges;
      return updatedFilterValue;
    });
  };

  const toGetTechnologiesValue = (technologies: string[]) => {
    setFilterValue((prev) => {
      const updatedFilterValue = { ...prev };
      updatedFilterValue.selectedTechnologies = technologies;
      return updatedFilterValue;
    });
  };

  const toGetPageValue = (pageValue: number) => {
    setFilterValue((prev) => {
      const updatedFilterValue = { ...prev };
      updatedFilterValue.page = pageValue;
      return updatedFilterValue;
    });
  };

  const toGetSearchValue = (searchValue: string) => {
    setFilterValue((prev) => {
      const updatedFilterValue = { ...prev };
      updatedFilterValue.searchText = searchValue;
      return updatedFilterValue;
    });
  };

  const [opportunityCount, setOpportunityCount] = useState<number>(0);

  return (
    <div className="opportunities-page-container">
      <OpportunityFilterContext.Provider value={filterValue}>
        <PageHeader
          title="Join an innovation Dream Team"
          background={HEADER_STYLES.COMMON.background}
          color={HEADER_STYLES.COMMON.color}
          actionBtn={
            <div style={{ display: 'flex', gap: 12 }}>
              <OpportunityGenerateReportButton
                disabled={opportunityCount === 0}
              />
              <OpportunitySubscriptionButton />
            </div>
          }
        />
        <OpportunityList
          editorSwitch={editorSwitch}
          pathName={PATH_NAME}
          onPositionsChange={toGetPositionsValue}
          onTechnologiesChange={toGetTechnologiesValue}
          onPageChange={toGetPageValue}
          onSearchChange={toGetSearchValue}
          onChallengesChange={toGetChallengesValue}
          onOpportunityCountChange={setOpportunityCount}
        />
      </OpportunityFilterContext.Provider>
    </div>
  );
}

export default Opportunities;
